import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {InvoicesService} from "../../data/invoices.service";

@Component({
  selector: 'invoice-make-concept',
  templateUrl: './invoice-make-concept.component.html',
  styleUrls: ['./invoice-make-concept.component.scss']
})
export class InvoiceMakeConceptComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private InvoicesService: InvoicesService
  ) { }

  @Input() invoice_id: number;
  @Input() invoiceNumber: string;

  @Output() onClose=new EventEmitter();
  @Output() onSuccess=new EventEmitter();

  ngOnInit(): void {
    this.addControls();
  }
  addControls() {
    this.form = this.formBuilder.group(
        {
          comments: new FormControl('' ),
        }
    );
  }
  get formControls() {
    return this.form.controls;
  }
  save() {
    let data={
      invoice_id: this.invoice_id,
      comments: this.formControls.comments.value
    }
    this.InvoicesService.makeConcept(data).subscribe(
        ()=>{},
        (error)=>console.error(error),
        ()=>this.onSuccess.emit()
    )
  }
  close() {
    this.onClose.emit();
  }
}
